<template>
  <div id="wrap">
    <Header/>
    <Scroll/>

    <div class="hp_performanceWrap">
      <div class="hp_mainSingleTitBox">
        <p>{{statusData.performanceData.performance_title}}</p>
        <p>{{statusData.performanceData.performance_sub_title}}</p>
      </div>
      <div class="hp_performanceEditor">
        <div v-if="isPC">
          <div v-editor-html="statusData.performanceData.performance_editor"/>
        </div>
        <div v-else>
          <div v-editor-html="statusData.performanceData.performance_editor_mobile"/>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref, computed } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_performance_one
} from '../../ETC/Axios.vue'

export default {
  name: 'Main',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    const statusData = ref({
      performanceData: []
    })

    const isPC = computed(() => {
      return window.innerWidth > 768
    })

    return {
      statusData,
      isPC
    }
  },
  mounted () {
    get_performance_one(this.$route.query.performance_ID).then(result_data => {
      this.statusData.performanceData = result_data[0]
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Performance/PerformanceDetail.vue